'use strict';

module.exports = {
  GET_STORE_BY_NUMBER: 'get-store-by-number',
  GET_RECOMMENDED_STORES: 'get-recommended-stores',
};
